// styles for react-responsive-modal plugin

export default Object.freeze({
    closeIconSize: 18,
    classNames: {
        modal: 'gym-modal cicd',
        closeButton: 'gym-modal__close',
    },
})
